import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Collapse,
  IconButton,
  Typography
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';

const ContactFilters = ({ filters, setFilters, applyFilters, handleDownload }) => {
  const [showFilters, setShowFilters] = useState(false); // filters hidden by default

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  return (
    <Box>
      {/* Header with Filter Icon */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          Contacts
        </Typography>
        <IconButton
          onClick={() => setShowFilters((prev) => !prev)}
          color="primary"
          sx={{
            backgroundColor: '#e3f2fd',
            '&:hover': { backgroundColor: '#bbdefb' }
          }}
        >
          <FilterListIcon />
        </IconButton>
      </Box>

      {/* Filter Box - collapsible */}
      <Collapse in={showFilters}>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
            mb: 3,
            p: 3,
            backgroundColor: 'white',
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            border: '1px solid rgba(0,0,0,0.05)',
            alignItems: 'center',
            '& .MuiTextField-root': {
              flex: 1,
              minWidth: 180
            }
          }}
        >
          <TextField
            label="Name"
            name="name"
            value={filters.name}
            onChange={handleChange}
            variant="outlined"
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 1,
                backgroundColor: '#f8fafc',
                '&:hover fieldset': {
                  borderColor: '#1976d2 !important'
                }
              }
            }}
          />

          <TextField
            label="Email"
            name="email"
            value={filters.email}
            onChange={handleChange}
            variant="outlined"
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 1,
                backgroundColor: '#f8fafc',
                '&:hover fieldset': {
                  borderColor: '#1976d2 !important'
                }
              }
            }}
          />

          <TextField
            label="Date From"
            name="dateFrom"
            type="date"
            value={filters.dateFrom}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 1,
                backgroundColor: '#f8fafc',
                '&:hover fieldset': {
                  borderColor: '#1976d2 !important'
                }
              }
            }}
          />

          <TextField
            label="Date To"
            name="dateTo"
            type="date"
            value={filters.dateTo}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 1,
                backgroundColor: '#f8fafc',
                '&:hover fieldset': {
                  borderColor: '#1976d2 !important'
                }
              }
            }}
          />

          <Button
            variant="contained"
            onClick={applyFilters}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 1,
              textTransform: 'none',
              fontWeight: 600,
              background: 'linear-gradient(135deg, #1976d2 0%, #2196f3 100%)',
              boxShadow: '0 2px 8px rgba(25, 118, 210, 0.2)',
              '&:hover': {
                boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                background: 'linear-gradient(135deg, #1565c0 0%, #1e88e5 100%)'
              },
              transition: 'all 0.3s ease'
            }}
          >
            Search
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            onClick={handleDownload}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 1,
              textTransform: 'none',
              fontWeight: 600,
              borderWidth: 2,
              '&:hover': {
                borderWidth: 2,
                backgroundColor: 'rgba(239, 68, 68, 0.04)'
              }
            }}
          >
            Download Selected
          </Button>
        </Box>
      </Collapse>
    </Box>
  );
};

export default ContactFilters;
